export const CustomFilters = {
    BackstageSelect: {
        styleOverrides: {
            root: {
                background: '#FAFAFA',
                padding: 8,
                borderRadius: 4,
                border: 'solid 1px #CCC',

                '& label': {
                    textTransform: 'uppercase',
                    fontSize: 12
                }
            }
        }
    },
    CatalogReactUserListPicker: {
        styleOverrides: {
            root: {
                backgroundColor: '#FAFAFA',
                border: 'solid 1px #CCC',
            },
        }
    },
    CatalogReactEntityOwnerPicker: {
        styleOverrides: {
            label: {
                textTransform: 'uppercase',
                fontSize: 12
            },
            root: {
                marginBottom: 16,
                background: '#FAFAFA',
                padding: 8,
                borderRadius: 4,
                border: 'solid 1px #CCC',
            }
        }
    },
    CatalogReactEntityProcessingStatusPickerPicker: {
        styleOverrides: {
            label: {
                textTransform: 'uppercase',
                fontSize: 12
            },
            root: {
                marginBottom: 16,
                background: '#FAFAFA',
                padding: 8,
                borderRadius: 4,
                border: 'solid 1px #CCC',
            }
        }
    },
    CatalogReactEntityAutocompletePicker: {
        styleOverrides: {
            label: {
                '& span': {
                    textTransform: 'uppercase',
                    fontSize: 12
                }
            },
            root: {
                marginBottom: 16,
                background: '#FAFAFA',
                padding: 8,
                borderRadius: 4,
                border: 'solid 1px #CCC',

                '& span': {
                    textTransform: 'uppercase',
                    fontSize: 12
                }
            }
        }
    },
    ScaffolderReactTemplateCategoryPicker: {
        styleOverrides: {
            label: {
                textTransform: 'uppercase',
                fontWeight: '700',
                marginBottom: 8,
                fontSize: 12
            },
            root: {
                marginBottom: 16,
                background: '#FAFAFA',
                padding: 8,
                borderRadius: 4,
                border: 'solid 1px #CCC',
            }
        }
    },
}